// extracted by mini-css-extract-plugin
export default {"readMore":"abstracted_content-module__readMore--7hx4s"};